export enum EModalKey {
  Inactivity = 'inactivityModalParams',
  TimeEditor = 'timeEditorModalParams',
  Complete = 'completeModalParams',
  Escalate = 'escalateModalParams',
}
